'use strict';
import productIndexBase from '../../pages/product/indexBase';
import miniCrossSell from './../../mini-crosssell';
import routineFeature from './../../routine-feature';
import fetchCompareProducts from './../../product-compare';
import crossSellTabs from '../../pages/cross_sell_tabs';

var product = {
    initializeEvents: productIndexBase.initializeEvents,
    init: function () {
        productIndexBase.init();
        fetchCompareProducts.init();
        miniCrossSell.init();
        crossSellTabs.init();
        if (SitePreferences.REGIMEN_VERSION_MODE == null || SitePreferences.REGIMEN_VERSION_MODE == 'new') {
            routineFeature.init();
        }
    }
};

$(".cross-section").on("click", function() {
    const $redirectUrl = $(this).attr("data-href");
    window.location.href = $redirectUrl;
});

export default product;
